export default "__VITE_ASSET__bd1dd7ca__"